<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Z1X4m6/tc-custom/9781685505127.jpg?1718169832880" alt="This image is the cover for the book Town Bronze"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Town Bronze
      </h1>
      <p class="bookDescription body article font2">
        <p>At twenty-one, Jasper Goodhew is delighted to be freed from his parental constraints in rural Somerset and enjoy the delights of Regency London during the Season. As a follower in the fast set that runs around young buck Julian Buchanan, Jasper encounters many pleasures, from the elegance of Mayfair parties to the tawdry entertainments of Covent Garden’s taverns and brothels. However, when he meets silver fox Mortimer Cleverly, he discovers a hidden propensity for spanking.<br/><br/>Sir Mortimer is a seasoned and experienced gentleman who can spot a confused innocent at a hundred paces. Yet he’s unable to resist Jasper’s clueless appeal at least once. He feels a lurking sense of responsibility when Jasper returns for more. Aware of the dangers of such a connection with a confused young man, Mortimer attempts to mentor Jasper, leading them onto the safer ground of friendship.<br/><br/>But will the combination of his increasing attachment and Jasper's irresistible compulsion foil their best intentions?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellie Thomas
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79f73940